import { TCommonData, TLayout, TWidgetProps } from '@libs/types';
import clsx from 'clsx';
import React from 'react';
import { TVerticalLayoutOption } from '../../types/options';
import { getInlineStyles } from '../../utils/styles';
import styles from './css/verticalLayout.module.css';

export const VerticalLayout: React.FC<TWidgetProps<TCommonData, TVerticalLayoutOption> & TLayout> = ({ widget, children, margin }) => {
    // support only top, center, bottom
    const arrangement = widget.options?.arrangement ?? 'top';
    const alignment = widget.options?.alignment ?? 'start';

    const classNames = clsx(styles.verticalLayoutInner, styles[`alignment-${alignment}`], styles[`arrangement-${arrangement}`]);

    return (
        <div data-test={widget.uid} className={clsx('vertical-layout', styles.verticalLayout)}>
            <div className={classNames} style={getInlineStyles({ margin })}>
                {children}
            </div>
        </div>
    );
};
